import logo from "../resources/WTGL_transparent.png";
import mapleLeaf from "../resources/maple_leaf_white.svg";
import {Link} from 'react-router-dom'
import { useTheme } from '../utils/ThemeContext';

const logoFilter = {
  strangerthings: 'hue-rotate(240deg) saturate(2) brightness(0.85)',
  masters: 'sepia(0.7) hue-rotate(10deg) saturate(0.9) brightness(0.9)',
};

export default function Banner({ onClick }){
    const { theme, themeName } = useTheme();
    const logoSrc = theme.logo === 'canada' ? mapleLeaf : logo;
    const filter = logoFilter[themeName] || 'none';

    return(
        <>
        <div id="banner" className="banner">
            <table>
                <tbody>
                    <tr><td><Link to="/" onClick={onClick}><img src={logoSrc} alt="logo" className="bannerLogo" style={{ filter }} /></Link></td><td valign="middle"><h1 style={{ color: theme.navText }}>WTGL</h1></td></tr>
                </tbody>
            </table>
        </div>

        <style jsx="true">{`
            .banner{
                background-color: ${theme.navBg};
            }

            .bannerLogo{
                width: 75px;
                height: 75px;
            }
        `}
        </style>
        </>
      )
}
